import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { ControlPosition, Map, useMap } from "@vis.gl/react-google-maps";
import { useEffect, useRef, useState } from "react";
import { Theme } from "@silvertours/front-shared";
import { Markers } from "./Markers";
import { StyledMapControl, Wrapper } from "./GoogleMap.styles";
import { MobileStationsList } from "./MobileStationsList";
import { analytics } from "..";
var defaultZoom = 14;
// Map ID for styling based on predefined theming
var MAP_ID = "90171eac382c3c31";
var getBoundsZoomLevel = function(bounds, mapDim) {
    var latRad = function latRad(lat) {
        var sin = Math.sin(lat * Math.PI / 180);
        var radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
        return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
    };
    var zoom = function zoom(mapPx, worldPx, fraction) {
        return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
    };
    var WORLD_DIM = {
        height: 256,
        width: 256
    };
    var ZOOM_MAX = 21;
    var ne = bounds.getNorthEast();
    var sw = bounds.getSouthWest();
    var latFraction = (latRad(ne.lat()) - latRad(sw.lat())) / Math.PI;
    var lngDiff = ne.lng() - sw.lng();
    var lngFraction = (lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360;
    var latZoom = zoom(mapDim.height, WORLD_DIM.height, latFraction);
    var lngZoom = zoom(mapDim.width, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
};
export var GoogleMap = function(param) {
    var bbox = param.bbox, stations = param.stations;
    var map = useMap();
    var ref = useRef(null);
    var ref1 = useState(0), width = ref1[0], setWidth = ref1[1];
    var ref2 = useState(null), selectedMarker = ref2[0], selectMarker = ref2[1];
    var handleStationClick = function(stationId, stationKind) {
        if (stationKind) {
            // Does not track deselecting a station
            analytics.gtm.trackStationMapStationClick(stationKind);
        }
        selectMarker(stationId);
    };
    useEffect(function() {
        if (map && ref.current) {
            var bounds = new google.maps.LatLngBounds();
            if (bbox) {
                bounds.extend({
                    lat: bbox.north,
                    lng: bbox.west
                });
                bounds.extend({
                    lat: bbox.south,
                    lng: bbox.west
                });
                bounds.extend({
                    lat: bbox.north,
                    lng: bbox.east
                });
                bounds.extend({
                    lat: bbox.south,
                    lng: bbox.east
                });
            } else if (stations) stations.forEach(function(station) {
                bounds.extend({
                    lat: station.latitude,
                    lng: station.longitude
                });
            });
            map.fitBounds(bounds);
            map.panToBounds(bounds);
            var center = {
                lat: bounds.getCenter().lat(),
                lng: bounds.getCenter().lng()
            };
            var ref1 = ref.current.getBoundingClientRect(), actualWidth = ref1.width, actualHeight = ref1.height;
            var zoomLevel = getBoundsZoomLevel(bounds, {
                height: actualHeight,
                width: actualWidth
            });
            setWidth(actualWidth);
            map.setZoom(zoomLevel);
            map.setCenter(center);
        }
    }, [
        bbox,
        map,
        ref,
        stations
    ]);
    var isMobile = Theme.useIsMobileTouchDevice();
    return (stations === null || stations === void 0 ? void 0 : stations.length) ? /*#__PURE__*/ _jsx(Wrapper, {
        ref: ref,
        children: /*#__PURE__*/ _jsxs(Map, {
            mapId: MAP_ID,
            style: {
                width: "100%",
                height: "100%"
            },
            defaultZoom: defaultZoom,
            zoomControlOptions: {
                position: ControlPosition.TOP_RIGHT
            },
            streetViewControl: false,
            mapTypeControl: false,
            children: [
                /*#__PURE__*/ _jsx(Markers, {
                    stations: stations,
                    select: handleStationClick,
                    selected: selectedMarker
                }),
                isMobile && /*#__PURE__*/ _jsx(StyledMapControl, {
                    position: ControlPosition.LEFT_BOTTOM,
                    children: /*#__PURE__*/ _jsx(MobileStationsList, {
                        selectStation: handleStationClick,
                        selectedStation: selectedMarker,
                        stations: stations,
                        mapWidth: width
                    })
                })
            ]
        })
    }) : null;
};
